import axios from 'axios';

/**
 * Loads appVersion and plan from the client record.
 */
export async function fetchUserFeedbackContext(clientId) {
  if (!clientId) {
    return { appVersion: '', planAtSubmission: '' };
  }

  const { data: client } = await axios.post(
    `${process.env.REACT_APP_API}/users/get-client-by-id`,
    { id: clientId },
  );

  return {
    appVersion: client?.versionInfo?.version?.trim() || '',
    planAtSubmission: client?.subscriptionInfo?.plan || '',
  };
}

export async function submitFeedback(payload, authToken) {
  if (!authToken) {
    throw new Error('Not authenticated');
  }

  const { data } = await axios.post(
    `${process.env.REACT_APP_API}/feedback/submit`,
    payload,
    { headers: { AuthToken: authToken } },
  );

  return data.feedback;
}
